/**
 * @generated SignedSource<<28c846b2efd466254fa7838a28705714>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttendOccurrenceInput = {
  occurrenceId: string;
};
export type JoinEventButton_AttendOccurrenceMutation$variables = {
  input: AttendOccurrenceInput;
};
export type JoinEventButton_AttendOccurrenceMutation$data = {
  readonly response: {
    readonly attendance: {
      readonly attendedAt: string;
      readonly id: string;
    } | null;
  };
};
export type JoinEventButton_AttendOccurrenceMutation = {
  response: JoinEventButton_AttendOccurrenceMutation$data;
  variables: JoinEventButton_AttendOccurrenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AttendOccurrenceResponse",
    "kind": "LinkedField",
    "name": "attendOccurrence",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OccurrenceAttendance",
        "kind": "LinkedField",
        "name": "attendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attendedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JoinEventButton_AttendOccurrenceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JoinEventButton_AttendOccurrenceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6da2ec70dd867a4de39bdb8c0a56cfa2",
    "id": null,
    "metadata": {},
    "name": "JoinEventButton_AttendOccurrenceMutation",
    "operationKind": "mutation",
    "text": "mutation JoinEventButton_AttendOccurrenceMutation(\n  $input: AttendOccurrenceInput!\n) {\n  response: attendOccurrence(input: $input) {\n    attendance {\n      id\n      attendedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a124ff51118c15ed513469317dd2b07a";

export default node;
